// extracted by mini-css-extract-plugin
export var dropdown = "_u9-0";
export var imageWrapper = "_u9-3";
export var itemNameContainer = "_u9-1";
export var productImage = "_u9-2";
export var spinnerWrapper = "_u9-4";